import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcContractTable from '@contracts/components/tables/contract-table/contract-table.vue';

@Component({
  name: 'bpc-contract',
  components: {
    'bpc-contract-table': BpcContractTable,
  },
})
export default class Contract extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
